<form [formGroup]="form" (ngSubmit)="save()">
  <div class="c-acc-panel c-acc-panel--edit c-acc-panel--edit-top">
    <div class="c-form-field">
      <label class="c-form-field__label">
        <span>{{ 'MY-ACCOUNT/MY-PRIVACY.shareDetailsLabel' | translate}}</span>
      </label>
      <div class="c-form-field__input">
        <div class="c-input c-input--checkbox">
          <input formControlName="shareDetailsWithProviderOptIn" type="checkbox" id="shareDetailsWithProviderOptIn">
          <label class="c-form-field__label" for="shareDetailsWithProviderOptIn">{{ 'MY-ACCOUNT/MY-PRIVACY.shareDetailsCheckbox' | translate}}</label>
        </div>
      </div>
    </div>

    <div class="c-form-buttons  [ o-layout o-layout--auto ]">
      <div class="o-layout__item">
        <button type="submit" class="c-btn c-btn--primary">{{ 'MY-ACCOUNT/MY-PRIVACY.Save' | translate}}</button>
      </div>
      <div class="o-layout__item">
        <a class="c-btn c-btn--tertiary" (click)="cancel()">{{ 'MY-ACCOUNT/MY-PRIVACY.Cancel' | translate}}</a>
      </div>
    </div>
  </div>
</form>
